import { z } from 'zod'
import type { WeekdayKey } from '@/types/onboarding'

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/

const timeBlockSchema = z
  .object({
    start_time: z.string().regex(TIME_PATTERN, 'Invalid time'),
    end_time: z.string().regex(TIME_PATTERN, 'Invalid time'),
  })
  .refine((block) => block.start_time < block.end_time, {
    message: 'End time must be after start time',
    path: ['end_time'],
  })

export const availabilityStepDataSchema = z.object({
  weekly: z.object({
    monday: timeBlockSchema.nullable(),
    tuesday: timeBlockSchema.nullable(),
    wednesday: timeBlockSchema.nullable(),
    thursday: timeBlockSchema.nullable(),
    friday: timeBlockSchema.nullable(),
    saturday: timeBlockSchema.nullable(),
    sunday: timeBlockSchema.nullable(),
  }),
})

export const WEEKDAYS: { key: WeekdayKey; label: string }[] = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
]
